import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { TECH_SKILLS } from "../../../constants";
import { errorHandler } from "../../../utils";
import classes from "./SelfDevelopment.module.css";
import { getAllSelfDevelopment } from "../../../services/talentCalls";
import Select from "react-select";
import { parseYouTubeURL, selectStyle } from "../../../utils/functions";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";
import ReactPlayer from "react-player";
import { ChevronDown } from "../../../constants/svg";
import Loop2 from "../../../assets/loader/loop2.svg";

const VideoContainer = ({ videoData, setCurrentPlaying, setCurrentVideo }) => {
  return (
    <div className={classes.videoGroup}>
      {videoData?.map((item, idx) => (
        <div
          className={`${classes.containerCard}`}
          key={item?._id}
          onClick={() => {
            setCurrentPlaying(true);
            setCurrentVideo({
              title: item?.title,
              url: item?.url,
              category: item?.category,
            });
          }}
        >
          <div
            onClick={() => {
              setCurrentPlaying(true);
              setCurrentVideo({
                title: item?.title,
                url: item?.url,
                category: item?.category,
              });
            }}
            style={{ position: "relative", width: "100%", height: "131px" }}
          >
            <ReactPlayer
              url={item?.url}
              width="100%"
              height="131px"
              light
              style={{
                pointerEvents: "none",
                background: "#f5f5f5",
                borderRadius: "10px 10px 0px 0px",
              }}
            />
          </div>
          <div className={classes["video-title"]}>
            <h3>{item?.title}</h3>
            <span>{item?.category}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

const SelfDevelopment = () => {
  const [state, setState] = useState("Designers");
  const [skill, setSkill] = useState("");
  const [videoData, setVideoData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPlaying, setCurrentPlaying] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({
    title: "",
    url: "",
    category: "",
  });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();

  const bottomRef = useRef(null);

  useEffect(() => {
    const skill = localStorage.getItem("desired-skill");
    if (!skill) return;
    else setState(skill);
  }, []);

  const handleChange = (e) => {
    setState(e.target.value);
    setCurrentPlaying(false);
    setCurrentVideo({ title: "", url: "", category: "" });
    setPage(1);
    setVideoData([]);
  };

  const getVideoData = async (selectedState = state, currentPage = 1) => {
    try {
      setLoading(true);
      const res = await getAllSelfDevelopment(selectedState, currentPage);
      setLoading(false);
      const records = res?.data?.data?.records || [];

      setVideoData((prev) => {
        if (currentPage === 1) {
          return records;
        }

        // Filter out duplicates by checking if _id already exists
        const existingIds = new Set(prev.map((item) => item._id));
        const newRecords = records.filter((item) => !existingIds.has(item._id));

        return [...prev, ...newRecords];
      });

      // pick a random video as recommendation on first page load
      if (currentPage === 1 && records.length > 0) {
        const random = records[Math.floor(Math.random() * records.length)];
        setCurrentVideo({ title: random.title, url: random.url, category: random.category });
        setCurrentPlaying(true);
      }

      setHasMore(records.length > 0);
    } catch (error) {
      setLoading(false);
      errorHandler(
        error?.response?.data?.errors || "Something went wrong.",
        "Error"
      );
    }
  };

  // useEffect(() => {
  //   getVideoData(state, page);
  // }, [state, page]);
  useEffect(() => {
    if (!loading) {
      setLoading(true);
      getVideoData(state, page).finally(() => setLoading(false));
    }
  }, [state, page]);

  // Setup Intersection Observer
  useEffect(() => {
    if (loading || !hasMore) return;
    const observerInstance = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPage((prev) => prev + 1);
        }
      },
      { threshold: 1.0 }
    );
    if (bottomRef.current) observerInstance.observe(bottomRef.current);
    return () => observerInstance.disconnect();
  }, [loading, hasMore]);

  const playerUrl = useMemo(() => currentVideo?.url || "", [currentVideo?.url]);

  return (
    <div className={classes.main}>
      {loading && page === 1 && <FullScreenLoader />}
      <div className={classes.header}>
        <h2>Self Development</h2>

        <div className={classes.selectGroup}>
          <select className="input" onChange={handleChange}>
            {TECH_SKILLS.map((skill, index) => (
              <option value={skill} key={`skill-${index}`}>
                {skill}
              </option>
            ))}
          </select>
          <ChevronDown color={"#000000"} />
        </div>
      </div>

      <div className={classes.videos}>
        {currentPlaying && playerUrl && (
        <div className={classes.videoFull}>
            <ReactPlayer
              url={parseYouTubeURL(playerUrl)}
              playing={playing}
              width="100%"
              height="390px"
              style={{
                opacity: videoLoading ? 0.5 : 1,
                background: "#f5f5f5",
              }}
              controls
              onReady={() => setVideoLoading(false)}
              onBuffer={() => setVideoLoading(true)}
              onBufferEnd={() => setVideoLoading(false)}
            />
          <div className={classes["video-section"]}>
            <div>
            <p className={classes.topVideo}>Top Suggestion</p>
            <h3>{currentVideo?.title}</h3>
            <p>{currentVideo?.category}</p>
            </div>
            <button className={classes["play-btn"]} onClick={() => setPlaying(!playing)}>
              {playing ? "Pause" : "Watch"}
            </button>
          </div>
        </div>
        )}

        <div>
          <VideoContainer
            videoData={videoData}
            setCurrentPlaying={setCurrentPlaying}
            setCurrentVideo={setCurrentVideo}
          />
          {loading && <img src={Loop2} alt="loader" type="loader" />}
          <div ref={bottomRef} style={{ height: "1px" }} />
        </div>
      </div>
    </div>
  );
};

export default SelfDevelopment;
